function Permission({ item, name, handleChange, disabled, indent = 0 }: any) {
  const handleCheck = (e: any) => {
    handleChange({
      target: {
        value: item?.KEY,
        name: `${name}_${item?.KEY}`,
        checked: e.target.checked,
      },
    });
  };

  return (
    <div
      className={`flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors ${
        disabled ? "opacity-60" : ""
      }`}
      style={{ marginLeft: indent * 24 }}
    >
      <label className="relative flex items-center cursor-pointer">
        <input
          name={`${name}_${item?.KEY}`}
          onChange={handleCheck}
          type="checkbox"
          checked={item?.checked}
          disabled={disabled}
          className="sr-only peer"
        />
        <div className={`w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all ${
          item?.checked
            ? "bg-indigo-500 border-indigo-500"
            : "border-slate-300 bg-white"
        } ${disabled ? "cursor-not-allowed" : "cursor-pointer"} ${!item?.checked ? "dark:border-slate-600 dark:bg-slate-700" : ""}`}>
          {item?.checked && (
            <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      </label>
      <span className={`text-sm font-medium ${item?.checked ? "text-slate-800 dark:text-slate-100" : "text-slate-500 dark:text-slate-400"}`}>
        {item?.NAME}
      </span>
    </div>
  );
}

export default Permission;
